(ns frontend.view.profile.components.auth
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require
   [reagent.core :as r]
   [common.localization :as loc]
   [common.security.authentication :as authentication]
   [frontend.state.current-session :as session]
   [frontend.view.profile.events :as events]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.profile.db :as db]
   [ui.components.button.view :as button]
   [ui.components.alert.view :as alert]
   [ui.editors.labelled-input.view :as labelled-input]))

(defn mfa-input-1
  [state kw]
  [labelled-input/view
   {:label     (loc/tr :mfa-code-1)
    :data-type :data.type/text-simple
    :value      (get @state kw)
    :on-change (fn [new-val]
                 (swap! state assoc kw new-val))}])

(defn mfa-input-2
  [state kw]
  [labelled-input/view
   {:label     (loc/tr :mfa-code-2)
    :data-type :data.type/text-simple
    :value      (get @state kw)
    :on-change (fn [new-val]
                 (swap! state assoc kw new-val))}])

(defn reset-2fa-button
  [account-id tenant-id]
  [button/sm-secondary-hollow
   {:on-click   (without-default-action-and-propagation
                 (modals/open-modal!
                  confirmation/modal-key
                  {:body          [:div
                                   [:p
                                    (loc/tr (if (= account-id (:db/id @session/account))
                                          :mfa-setup-confirm
                                          :mfa-setup-confirm-other))]]
                   :confirm-text  (loc/tr :mfa-setup-confirm-button)
                   :checkbox-text (loc/tr :i-understand-theres-no-undo-for-this)
                   :confirm-icon  nil
                   :on-confirm    #(events/reset-mfa! account-id tenant-id)}))}
   (loc/tr :mfa-reset)])

(defn disable-2fa-button
  [account-id tenant-id]
  [button/sm-danger-solid
   {:class "me-2"
    :on-click   (without-default-action-and-propagation
                 (modals/open-modal!
                  confirmation/modal-key
                  {:body          [:div
                                   [:p (loc/tr :mfa-deactivate-confirm)]]
                   :confirm-text  (loc/tr :mfa-deactivate-confirm-button)
                   :checkbox-text (loc/tr :i-understand-theres-no-undo-for-this)
                   :on-confirm    #(events/deactivate-mfa! account-id)}))}
   (loc/tr :mfa-deactivate)])

(defn enable-2fa-button
  [account-id tenant-id]
  [button/sm-primary-solid
   {:class "me-2"
    :on-click   (without-default-action-and-propagation
                 (events/reset-mfa! account-id tenant-id))}
   (loc/tr :mfa-setup-new)]

)

(defn view
  [show-all? show-all!]
  (let [account @session/account
        tenant @session/tenant
        account-id (:db/id account)
        tenant-id (:db/id tenant)
        {:keys [image-data secret-key show-image? show-key? error info]} @db/mfa
        {:keys [account/mfa-status]} account
        sys-admin? (session/sys-admin?)
        mfa-status (if sys-admin?
                     (:account/sys-admin-mfa-status account)
                     mfa-status)
        assigned? (= mfa-status :mfa.status/assigned)]
    [:div
     {:class "pt-6 flex flex-col items-start gap-4"}
     [:div
      {:class "font-bold text-[18px]"}
      (loc/tr :two-factor-authentication)]
     (when sys-admin?
       [:div
       {:class "text-base-light-text-paler"} 
        "Logged in as sys-admin. Sys-admin MFA secret-key & codes are not tenant specific"])

     (cond
       (and image-data secret-key)
       nil                                                  ;; do not show button when activating
       (or sys-admin?
           (and assigned? (authentication/mfa-mandatory? tenant)))
       [reset-2fa-button account-id tenant-id]
       assigned?
       [disable-2fa-button account-id tenant-id]
       :else
       [enable-2fa-button account-id tenant-id])

     [:div 
      {:class "w-64"}
      (when info
            [alert/info
             {:on-close    #(swap! db/mfa dissoc :info)}
             (loc/tr info)])]

     (when (and image-data secret-key)
       [:div
        [:span 
         {:class "font-bold text-base-light-text"}
         [:strong "1) "]
         (loc/tr :mfa-use-app-and-scan)]
        [:div 
         {:class "p-6 my-6 md:grid grid-cols-9 justify-center gap-8
                  bg-base-regular 
                  rounded"}
         (if show-image?
           [:div
            {:class "py-3 flex flex-col col-span-4 items-center gap-4"}
            [button/sm-secondary-solid
             {:on-click (without-default-action-and-propagation
                         (swap! db/mfa assoc :show-image? false))}
             (loc/tr :mfa-hide-qr)]
            [:div
             {:class-name "w-48 h-48 border border-solid border-base-light-border-paler bg-cover"
              :style      {:background-image (str "url(data:image/png;charset=utf-8;base64,"
                                                  image-data
                                                  ")")}}]]
           [:div
            {:class "py-3 flex flex-col col-span-4 items-center gap-4"}
            [button/sm-secondary-solid
             {:on-click (without-default-action-and-propagation
                         (swap! db/mfa assoc :show-image? true))}
             (loc/tr :mfa-show-qr)]
            [:div]])

         [:div 
          {:class "py-5 relative flex flex-row md:flex-col col-span-1 justify-center items-center"}
          [:div 
           {:class "flex-grow border-solid border-t md:border-l border-base-regular-border-paler"}]
          [:span 
           {:class "mx-4 flex-shrink text-gray-400"} "OR"]
          [:div 
           {:class "flex-grow border-solid border-t md:border-l border-base-regular-border-paler"}]] 

         (if show-key?
           [:div
            {:class "py-3 col-span-4 flex flex-col  items-center gap-4"}
            [button/sm-secondary-solid
             {:on-click (without-default-action-and-propagation
                         (swap! db/mfa assoc :show-key? false))}
             (loc/tr :mfa-hide-secret-key)]
            [:span
             {:class "p-2 inline-block 
                      font-bold
                      border border-solid border-base-light-border-paler
                      bg-base-light"}
             secret-key]]
           [:div
            {:class "py-3 col-span-4 flex flex-col  items-center gap-4"}
            [button/sm-secondary-solid
             {:on-click (without-default-action-and-propagation
                         (swap! db/mfa assoc :show-key? true))}
             (loc/tr :mfa-show-secret-key)]])]
       [:div
        {:class "mt-3 font-bold text-base-light-text"}
        [:strong "2) "]
        (loc/tr :mfa-type-two-codes)]
       (when error
         [alert/danger
          {:on-close    #(swap! db/mfa dissoc :error)}
          (loc/tr error)])
       [:div
        {:class "pt-3 flex flex-col gap-4"} 
        
        [mfa-input-1 db/mfa :mfa-1]
        [mfa-input-2 db/mfa :mfa-2]
        [:div
         {:class "flex flex-start"}
         [button/sm-primary-solid
          {:on-click   events/assign-mfa!}
          (loc/tr :mfa-submit-codes-button)]]]])]))
